module.exports = __webpack_public_path__ + "media/theme/congratulations-4bea82e0.svg";